import $ from '../tools/Dom';
import Viewport from '../tools/Viewport';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

export default el => {
    const OFFSET_BUFFER = 5;
    const OFFSET_TOP = 30;

    const dom = $(el);
    const menu = dom.find('[data-menu]');
    const bar = dom.find('[data-bar]');
    const lang = dom.find('[data-lang]');
    const langMobile = dom.find('[data-lang-mobile]');
    const langToggle = dom.find('[data-lang]').find('a');
    const langMobileToggle = dom.find('[data-lang-mobile]').find('a');
    const logo = dom.find('[data-logo]').find('a');
    let isOpen = false;
    let toggle;
    let scrollingLocked = false;
    let headerShowing = true;
    let lastTop = Viewport.scroll.top;
    let items = [];

    const toggleTabbing = shouldLock => {
        if (shouldLock) {
            Viewport.lockTabbing(el);
        } else {
            Viewport.releaseTabbing();
            Viewport.enableTabbingOnElement([toggle.get(0), logo.get(0)]);
        }
    };

    const show = () => {
        if (!headerShowing) {
            console.log('Header.show');
            headerShowing = true;

            TweenMax.to(items, 0.35, {yPercent: 0, ease: 'Quad.easeOut'});
            TweenMax.to(bar.get(0), 0.35, {yPercent: 0, ease: 'Quad.easeOut'});
            TweenMax.to(lang.get(0), 0.35, {yPercent: 0, ease: 'Quad.easeOut'});
            TweenMax.to(langMobile.get(0), 0.35, {yPercent: 0, ease: 'Quad.easeOut'});
        }
    };

    const hide = () => {
        if (headerShowing) {
            console.log('Header.hide');
            headerShowing = false;
            TweenMax.to(items, 0.25, {yPercent: -100, ease: 'Quad.easeIn'});
            TweenMax.to(bar.get(0), 0.25, {yPercent: -100, ease: 'Quad.easeIn'});
            TweenMax.to(lang.get(0), 0.25, {yPercent: -100, ease: 'Quad.easeIn'});
            lang.get(0).classList.remove('open')
            langMobile.get(0).classList.remove('open')
        }
    };

    langToggle.on('click', () => {
        lang.get(0).classList.toggle('open')
    })

    langMobileToggle.on('click', () => {
        langMobile.get(0).classList.toggle('open')
    })

    const onFocus = () => {
        if (!headerShowing) {
            console.log('onFocus');
            show();
        }
    };

    const setDevice = () => {
        const ua = navigator.userAgent;
        dom.toggleClass('is-android', ua.match(/(Android)/ig) !== null);
        dom.toggleClass('is-ios', ua.match(/(iPhone|iPad|iPod)/ig) !== null
        );
    };

    const onScroll = () => {
        if (!scrollingLocked) {
            const top = Viewport.scroll.top;
            if (Math.abs(top - lastTop) > OFFSET_BUFFER) {
                const isScrollingUp = top < lastTop;
                if (isScrollingUp) {
                    show();
                } else if (top > OFFSET_TOP) {
                    hide();
                }
                lastTop = top;
            }
        }
    };

    const onToggle = () => {
        const state = toggle.attr('aria-expanded') === 'true';
        isOpen = !state;
        toggle.attr('aria-expanded', isOpen);
        toggleTabbing(isOpen);
        dom.toggleClass('is-open', isOpen);
        scrollingLocked = isOpen;

        // Only disable body scroll on iOS devices, as it causes issues in Safari
        const
            is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent),
            is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

        if (!is_ios && !is_safari) {
            isOpen ? disableBodyScroll(dom) : enableBodyScroll(dom)
        }
    };

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (isOpen && key === 27) {
            onToggle();
        }
    };

    const enhance = () => {
        menu.prepend(`<button class="header__toggle" aria-label="${menu.data('menu')}" aria-expanded="false" data-toggle><span></span><span></span><span></span></button>`);
        dom.find('[data-toggle-link]').remove();
        toggle = menu.find('[data-toggle]');
        toggle.on('click', onToggle);
        Viewport.releaseTabbing();
        Viewport.enableTabbingOnElement([toggle.get(0), logo.get(0)]);
    };

    const onBreakpoint = data => {
        if (data.detail.current.size >= 980 && data.detail.old.size < 980) {
            dom.removeClass('is-mobile');
            const oldItems = items;
            items = [dom.find('[data-content]').get(0)];
            TweenMax.set(oldItems, {clearProps: 'all'});
            if (isOpen) {
                isOpen = false;
                toggle.attr('aria-expanded', false);
                Viewport.releaseTabbing();
            }
            Viewport.enableTabbingOnElement($('[data-tab-desktop]').get().concat(logo.get()));
        } else if (data.detail.current.size < 980 && data.detail.old.size >= 980) {
            dom.addClass('is-mobile');
            const oldItems = items;
            items = [dom.find('[data-logo]').get(0), toggle.get(0)];
            TweenMax.set(oldItems, {clearProps: 'all'});
            toggleTabbing(false);
        }
    };

    const init = () => {
        enhance();
        setDevice();
        if (Viewport.breakpoint.size < 980) {
            dom.addClass('is-mobile');
            items = [dom.find('[data-logo]').get(0), toggle.get(0)];
        } else {
            Viewport.enableTabbingOnElement($('[data-tab-desktop]').get().concat(logo.get()));
            items = [dom.find('[data-content]').get(0)];
        }
        Viewport.on('scroll', onScroll);
        Viewport.on('breakpoint', onBreakpoint);
        document.addEventListener('keyup', keyup);
        dom.on('focusin', onFocus);
    };

    const destroy = () => {
        document.removeEventListener('keyup', keyup);
        Viewport.off('scroll', onScroll);
        Viewport.off('breakpoint', onBreakpoint);
        dom.off('focusin', onFocus);
        toggle.off('click', onToggle);
    };

    return {
        init,
        destroy
    };
};
